import React, { useState, useEffect } from "react";

// Import Highcharts
import Highcharts from "highcharts";
import HCMore from "highcharts/highcharts-more";
import solidGauge from "highcharts/modules/solid-gauge";
import HighchartsReact from "highcharts-react-official";

HCMore(Highcharts);
solidGauge(Highcharts);

const PerformanceColumn = (props) => {
  var customIcon = [
    "nicon-education-new",
    "nicon-skills",
    "nicon-awards",
    "nicon-career",
    "nicon-goals",
  ];

  const [options, setOptions] = useState({
    chart: {
      type: "column",
      // marginTop: 0,
      // marginBottom: 0,
      backgroundColor:'transparent',
      height:props?.height
      // height: window.location.pathname === 'user/performance' ? 500 :  ,
    
    },
    tooltip: {
      enabled: true,
      formatter: function () {
        return (
          "<b>" +
          this.x +
          "</b><br/>" +
          this.series.name +
          ": " +
          Highcharts.numberFormat(this.y, 0) 
          
        );
      },
    },
    plotOptions: {
      column: {
        colorByPoint: true,
        groupPadding: 0,
        pointPadding: 0,
        borderWidth: 0,
      },
    },
    colors: ["#E54126", "#F49E1D", "#29B3AF", "#2F9CCA", "#24346E"],
    color2:['#93AEC7'],
    title: {
      text: "",
    },
    xAxis: {
      gridLineColor: "#bebebc",
      gridLineWidth: 1,
      categories: [
        "<strong>Experience</strong>",
        "<strong>Qual’s</strong>",
        // "<strong>Courses</strong>",
        "<strong>Training</strong>",
        "<strong>Systems</strong>",
        // "<strong>Competency</strong>",
        // "<strong>Skills</strong>",
      ],
      labels: {
        enabled: true,
        rotation: 0,
        align: "center",
        useHTML: true,
        formatter: function () {
          return (
            '<div class="custom-label" style="margin-top:15px;color:#666666;font-weight:600;font-size:14px;"><div class="label-value">' +
            this.value +
            "</div></div>"
          );
        },
        style: {
          fontSize: "11px",
          fontFamily: "Verdana, sans-serif",
          color:props?.color
        },
      },
    },
    yAxis: {
      min: 0,
      gridLineWidth: 0,
      title: {
        enabled: false,
      },
      labels: {
        enabled: false,
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      formatter: function () {
        return (
          "<b>" +
          this.x +
          "</b><br/>" +
          this.series.name +
          ": " +
          Highcharts.numberFormat(this.y, 0) 
          
        );
      },
    },
    series: [
      {
        name: "My Score",
        data: props?.data,
        data:[85,66,150,45],
        dataLabels: {
          enabled: false,
          rotation: -90,
          color: "#FFFFFF",
          align: "top",
          y: -80,
          useHTML: true,
          formatter: function () {
            return (
              '<div className="top-label"><span style="color:' +
              this.color +
              ';">' +
              this.y +
              " %</span></div>"
            );
          },
        },
      },
      {
        name:'Peers Score ',
        data:props?.peersData,
        data:[85,66,150,45],
        colors: ["#93AEC7", "#93AEC7", "#93AEC7", "#93AEC7"],
        dataLabels: {
          enabled: true,
          rotation: 0,
          color: "#FFFFFF",
          align: "top",
          y: -80,
          useHTML: true,
          formatter: function () {
            return (
              '<div className="top-label"><span style="color2:' +
              this.color2 +
              ';">' +
              this.y +
              " %</span></div>"
            );
          },
        },
      }
    ],
   
  });

  useEffect(() => {
    var customIcon = [
      "nicon-education-new",
      "nicon-skills",
      "nicon-awards",
      "nicon-career",
      "nicon-goals",
    ];

    if (props.data !== undefined) {
      setOptions({
        chart: {
          type: "column",
          marginTop: 0,
        },
        tooltip: {
          enabled: true,
        },
        plotOptions: {
          column: {
            colorByPoint: true,
            groupPadding: 0.1,
            pointPadding: 0.05,
            borderWidth: 0,
          },
        },
        colors: ["#E54126", "#F49E1D", "#29B3AF", "#2F9CCA", "#24346E"],
        color2:['#93AEC7'],
        title: {
          text: "",
        },
        xAxis: {
          gridLineColor: "#bebebc",
          gridLineWidth: 1,
          categories: [
            "<strong>Experience</strong>",
            "<strong>Qual’s</strong>",
            // "<strong>Courses</strong>",
            "<strong>Training</strong>",
            "<strong>Systems</strong>",
            // "<strong>Competency</strong>",
            // "<strong>Skills</strong>",
          ],
          labels: {
            rotation: 0,
            align: "center",
            useHTML: true,
            formatter: function () {
              return (
                '<div className="custom-label"><div className="icon"><img src=""><span style="color:' +
                this.chart.userOptions.colors[this.pos] +
                ';" className="ni ' +
                customIcon[this.pos] +
                '"></span></div><div className="label-value">' +
                this.value +
                "</div></div>"
              );
            },
            style: {
              fontSize: "8px",
              fontFamily: "Verdana, sans-serif",
              color:props?.color
            },
          },
        },
        yAxis: {
          min: 0,
          gridLineWidth: 0,
          title: {
            enabled: false,
          },
          labels: {
            enabled: false,
          },
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "My Score",
            // data:[150,55,96,80],

            data: props.data,
            // data:props?.data,
            dataLabels: {
              enabled: false,
              rotation: 0,
              color: "#FFFFFF",
              align: "top",
              y: -80,
              useHTML: true,
              formatter: function () {
                return (
                  '<div className="top-label"><span style="color:' +
                  this.color +
                  ';">' +
                  this.y +
                  " %</span></div>"
                );
              },
            },
          },
          {
            name:'Peers Score ',
            // data:[150,55,96,80],
            data:props?.peersData,
            colors: props?.color === 'white'? ["#93AEC7", "#93AEC7", "#93AEC7", "#93AEC7"]:["#f39e92", "#face8e", "#8fdad7", "#94cde5"] ,
            dataLabels: {
              enabled: false,
              rotation: 0,
              color: "#FFFFFF",
              align: "top",
              y: -80,
              useHTML: true,
              formatter: function () {
                return (
                  '<div className="top-label"><span style="color2:' +
                  this.color2 +
                  ';">' +
                  this.y +
                  " %</span></div>"
                );
              },
            },
          }
        ],
        
   
      });
    }
  }, [props]);

  return <HighchartsReact highcharts={Highcharts} options={options}  />;
};

export default PerformanceColumn;
